import { Dispatch, SetStateAction } from "react";

import { Checkbox } from "@/shadcn/components/ui/checkbox";

type MultiCheckboxProps<T extends string> = {
  searchTypes: readonly T[] | T[];
  selectedType: T;
  setSelectedType: Dispatch<SetStateAction<T>>;
};

const MultiCheckbox = <T extends string>({
  searchTypes,
  selectedType,
  setSelectedType,
}: MultiCheckboxProps<T>) => {
  return (
    <div className="flex flex-row gap-2 w-full align-middle items-center">
      {searchTypes.map((type) => (
        <div key={type} className="flex items-center">
          <Checkbox
            className="mr-2 scale-90"
            checked={selectedType === type}
            onCheckedChange={() => setSelectedType(type)}
            id={type}
          />
          <label htmlFor={type} className="font-light text-sm">
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </label>
        </div>
      ))}
    </div>
  );
};

export default MultiCheckbox;
